// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"4a4fedfc","130":"fbc8a7ee","399":"9e9a30d2","446":"35e4de38","483":"9dd0e7d1","787":"09c7dba2"}[chunkId] + ".chunk.js";
};